import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M440-146q-23 0-38-16-16-15-16-38v-235L150-737q-19-24-6-51 14-27 44-27h584q30 0 44 27 13 27-6 51L575-435v240q0 21-15 35-14 14-35 14h-85Zm40-298 229-291H251l229 291Zm0 0Z"/>',
  f: '<path d="M440-146q-23 0-38-16-16-15-16-38v-235L150-737q-19-24-6-51 14-27 44-27h584q30 0 44 27 13 27-6 51L575-435v240q0 21-15 35-14 14-35 14h-85Z"/>',
};

export default data;
